(() => {
  const headerButton = document.querySelector('.menuline .mobile-button');

  if (window.matchMedia('(max-width: 1024px)').matches && headerButton) {
    headerButton.addEventListener('click', () => {
      headerButton.classList.toggle('open');
    })

    const subMenus = Array.from(document.querySelectorAll('.menu-item-has-children'));
    if (subMenus) {
      subMenus.forEach((subMenu) => {
        subMenu.addEventListener('click', () => {
          subMenu.querySelector('.sub-menu').classList.toggle('open');
        })
      })
    }
  }
})()
